import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {environment} from '../../../../environments/environment';
import {catchError, map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FinancialOperationRefundService {

  constructor(
    private http: HttpClient
  ) { }

  public refund(
    id: number,
    amount: number | null = null,
    accumulationOrTransferFinancialOperationId: number| null = null
  ): Observable<boolean> {
    const data: {[key: string]: number} = {financialOperationId: id};
    if (amount !== null) {
      data.amount = amount;
    }
    if (accumulationOrTransferFinancialOperationId !== null) {
      data.accumulationOrTransferFinancialOperationId = accumulationOrTransferFinancialOperationId;
    }
    return this.http.post<{success: boolean}>(
      environment.apiBasepoint + 'financial-operation-refund',
      data,
      {
        observe: 'body',
      }
    ).pipe(
      catchError(() => of({success: false})),
      map(value => value.success)
    );
  }
}
